import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appOnlyNumbers]'
})
export class OnlyNumbersDirective
{

  @Input() public maxDigits?: number; // parámetro opcional

  @HostListener('input', ['$event'])
  public onInputChange(event: Event): void
  {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/[^0-9]/g, ''); // solo números

    if (this.maxDigits && value.length > this.maxDigits)
    {
      value = value.substring(0, this.maxDigits); // cortar si excede
    }

    input.value = value;
  }
}
